








































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwModal } from '@libs-uuif/shared/sw-modal';

const cssPrefix = 'release-notes';

@Component({
  components: {
    ...UUIFComponents,
    SwIcon,
    SwModal,
    SwButton,
  },
})

export default class ReleaseNotes extends SwExtendedVue {
  cssPrefix = cssPrefix;
  show: boolean = false;

  toggleShow() {
    this.show = !this.show;
  }
}
